export default __webpack_public_path__ + "static/media/logo.eab6f9ac.png";